import {
  ActivitySummaryResponse,
  ClientListResponse,
  GetCreditFromBirthDateResponse,
  ModificationHistoryListResponse,
  VerifyEmailCodeSchemaResponse
} from '@/modules/sales/clients/services/apiValidation/apiValidationSchemas.ts'
import { ClientDetail } from '@/modules/sales/clients/types/Client.ts'
import {
  TransactionListResponse,
  WalletResponse
} from '@/modules/sales/clients/components/clientDetails/components/clientTabs/tabs/walletContainer/services/apiValidationSchemas.ts'
import { PersonalDataResponse } from '@/modules/sales/clients/services/apiValidation/personalDataApiValidation.ts'
import { PersonalDocsResponseSchema } from '@/modules/sales/clients/services/apiValidation/personalDocsApiValidation.ts'

const mockDocumentImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=='

export const clientsPage1: { data: ClientListResponse; message: string } = {
  message: 'OK',
  data: {
    results: [
      {
        creditId: '1',
        clientId: '2',
        userClientId: null,
        clientName: 'Grisel Estrada',
        phone: '+58123456788',
        email: 'genamorado88@gmail.com',
        documentNumber: '123456',
        credit: '9200.00',
        isEmailVerify: true,
        isPhoneVerify: true,
        isBiometricVerify: true,
        isMovistarClient: null,
        isZoneUClient: false,
        isLocked: false,
        createByName: 'Dairo Test',
        levelId: '1',
        levelName: 'Nivel 1 - Bronce'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 1,
      limit: 0
    }
  }
}

export const clientDetail: { data: ClientDetail } = {
  data: {
    id: '731997',
    referralCode: 'gUEMFCAbWK',
    address: 'asd',
    walletId: 'c10a432d-6c63-4bdf-bc9a-b0723d6a38af-client',
    name: 'chicho',
    lastName: 'el cojo',
    phone: '+529622054204',
    email: 'chicho.el.cojo96@gmail.com',
    documentNumber: '26745781',
    creditLimit: '1370.05',
    creditLimitMiscellaneous: '808.00',
    age: '25-30',
    isEmailVerify: true,
    isBiometricVerify: true,
    isPhoneVerify: true,
    birthDate: '14/05/2020',
    accountNumber: '01020000000000000000',
    accountType: 'AHORRO',
    accountPhone: '9625140142',
    gender: 'MASCULINO',
    maritalStatus: 'CASADO',
    occupation: 'Trabajador independiente',
    createByName: 'Nombre_3039 Apellido_3039',
    initialByLevel: '25.00',
    uuid: 'ade0d4e015b941e6b2ad8aa9d56c9981',
    isMovistarClient: null,
    isZoneUClient: null,
    levelId: '2',
    levelName: 'Nivel 2 - Plata',
    levelRechargeDiscount: '10.00',
    levelActiveDevices: 2,
    rentabilityId: '1',
    rentabilityQuotes: '6',
    rentabilityExchange: '1.39',
    rentabilityTimesQuotes: '15',
    rentabilityIsMain: false,
    credits: [
      {
        creditId: '423340',
        registerNumber: '213123123123123123123',
        quotes: [
          {
            quoteId: '3690813',
            creditId: '423340',
            paymentDate: '11/09/2026',
            dueAt: '25/08/2026',
            quote: '21.00',
            paid: '21.00',
            status: 'PAGADA'
          },
          {
            quoteId: '3690814',
            creditId: '423340',
            paymentDate: null,
            dueAt: '28/08/2026',
            quote: '21.00',
            paid: '0.00',
            status: 'PENDIENTE'
          },
          {
            quoteId: '3690815',
            creditId: '423340',
            paymentDate: null,
            dueAt: '29/08/2026',
            quote: '21.00',
            paid: '0.00',
            status: 'PENDIENTE'
          },
          {
            quoteId: '3690816',
            creditId: '423340',
            paymentDate: null,
            dueAt: '30/08/2026',
            quote: '21.00',
            paid: '0.00',
            status: 'PENDIENTE'
          }
        ]
      }
    ],
    clientAddress: {
      id: '397',
      name: '8WGR+GX, El Roble 6057, Anzoátegui, Venezuela',
      address: '8WGR+GX, El Roble 6057, Anzoátegui, Venezuela',
      lat: '8.32552755',
      lng: '-65.05855919',
      isFavorite: false,
      isActive: true,
      referencePoint: 'mi casa',
      state: 1,
      city: 104,
      type: 'HOME',
      sectorName: 'HUACHAMACARE',
      sectorId: 409,
      sectorEntityName: 'HUACHAMACARE',
      createdAt: '14/09/2026'
    },
    workAddress: null,
    photo: null
  }
}

export const verifyEmailCode: { data: VerifyEmailCodeSchemaResponse } = {
  data: {
    email: 'ynascolopez@gmail.com',
    clientUuid: '68711ceb6666d369080120',
    clientId: 2
  }
}

export const getCreditFromBirthday: { data: GetCreditFromBirthDateResponse } = {
  data: { credit: 700 }
}

export const modificationHistoryPage1: {
  data: ModificationHistoryListResponse
  message: string
} = {
  message: 'OK',
  data: {
    results: [
      {
        id: '12',
        name: 'Test',
        lastName: 'Test',
        phone: '65656565',
        email: 'test@test.com',
        documentNumber: 'FD028',
        status: 'NUEVA',
        reason: null,
        birthDate: '23/05/1988',
        createdAt: '21/07/2025',
        updatedBy: 'Admin Test',
        creditLimit: '390'
      },
      {
        id: '13',
        name: 'Test',
        lastName: 'Test',
        phone: '65656565',
        email: 'test@test.com',
        documentNumber: 'FD028',
        status: 'NUEVA',
        reason: null,
        birthDate: '23/05/1988',
        createdAt: '21/07/2025',
        updatedBy: 'Admin Test',
        creditLimit: '500'
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 1,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 0
    }
  }
}

export const paymentTypes = {
  message: 'OK',
  data: [
    {
      id: '1',
      label: 'Transferencia'
    },
    {
      id: '2',
      label: 'Efectivo (USD)'
    },
    {
      id: '3',
      label: 'Efectivo (Bs)'
    }
  ]
}

export const transactionsPage1: TransactionListResponse = {
  total: 4,
  totalPages: 1,
  limit: 10,
  currentPage: 0,
  data: [
    {
      id: 123,
      amount: 250.0,
      description: null,
      reference: 'BUY12092025-769364',
      type: 'BUY',
      status: 'COMPLETED',
      wallet: {
        id: '123456789012345678901234567890123456',
        balance: 10.0,
        documentNumber: '12356',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-09-12T17:50:15.263600Z',
      details: {
        modelName: 'EDGE 40 NEO',
        categoryName: 'Videojuegos',
        productPrice: 399.99,
        productTypeName: 'Teléfonos',
        sender: {
          name: 'Dairo Test'
        },
        receiver: {
          name: 'Dairo Test2'
        },
        ally: '',
        branch: '',
        walletId: '',
        clientName: '',
        employeeName: '',
        allyDecreaseTransaction: 0
      },
      balance: 0
    }
  ]
}

export const wallet: WalletResponse = {
  id: '123456789012345678901234567890123456',
  balance: 10.0,
  documentNumber: '12356',
  currency: {
    code: 'USD',
    label: 'USD',
    exchangeBuy: 1.0,
    exchangeSell: 1.0,
    mainCurrency: true
  },
  status: 'ACTIVE'
}

export const transactionSearchClient: TransactionListResponse = {
  total: 104,
  totalPages: 6,
  limit: 20,
  currentPage: 0,
  data: [
    {
      id: 2161465,
      amount: 1.16,
      description: null,
      reference: 'PAY23032026-358039',
      type: 'PAY',
      status: 'COMPLETED',
      wallet: {
        id: '8bd33d55-48ba-4142-bddc-9603d80ae99d-client',
        balance: 5002.53,
        documentNumber: '88888888',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1,
          exchangeSell: 1,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2026-03-23T15:02:40.563688Z',
      details: {
        name: 'Digitel Prepago - 04220141303 (Original: 300.00 BS → 0.66 USD)',
        brand: 'SERVICIO',
        model: 'CRÉDITO',
        source: 'PAGO MANUAL',
        dueDate: '2026-04-07T11:02:20.848166Z',
        quoteId: 3863388,
        creditId: 449818,
        remaining: 0,
        amountPaid: 1.16,
        paymentType: 'CUOTA COMPLETA',
        quoteAmount: 1.16,
        creditRegisterNumber: '1774278140848'
      },
      balance: 4843.01
    },
    {
      id: 995,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-076853',
      type: 'RECHARGE',
      status: 'REVERSED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:59:24.986114Z',
      details: {
        originalAmount: 8276.06,
        originalCurrency: 'BS',
        currencyCalculation: {
          BS: {
            amount: 8276.06,
            exchangeRate: 285.4
          },
          USD: {
            amount: 29,
            exchangeRate: 1
          }
        }
      },
      balance: 0
    },
    {
      id: 993,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-036091',
      type: 'DIRECT_RECHARGE',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:52:36.169453Z',
      details: {
        ally: 'Anotherone',
        branch: 'Sucursal Palmolive',
        reversed: true,
        walletId: '40b406db-ad0f-4ca8-bdca-b95f3b05efe6-ally',
        clientName: 'Galileo Galilei',
        employeeName: 'Juaquina Pamplina',
        allyDecreaseTransaction: 846914
      },
      balance: 0
    },
    {
      id: 991,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-733530',
      type: 'PAY',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:52:27.077884Z',
      details: {
        name: 'Cuota 3 de 8',
        brand: 'APPLE 13',
        model: 'APPLE',
        source: 'PAGO MANUAL',
        dueDate: '2026-02-20T00:00:00Z',
        quoteId: 3670984,
        creditId: 420634,
        remaining: 11,
        amountPaid: 10,
        paymentType: 'CUOTA PARCIAL',
        quoteAmount: 21,
        creditRegisterNumber: 'H1QR661VH6'
      },
      balance: 0
    },
    {
      id: 989,
      amount: 5.0,
      description: '',
      reference: '999REC17122025-276494',
      type: 'TRANSFER_SENT',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:52:20.381537Z',
      details: {
        modelName: '123',
        description: null, //string
        categoryName: '123',
        productPrice: 200,
        productTypeName: '123'
      },
      balance: 0
    },
    {
      id: 987,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-059156',
      type: 'PAY_SERVICE',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:52:14.061962Z',
      details: {
        uuid: '123',
        serviceName: 200,
        number: '123'
      },
      balance: 0
    },
    {
      id: 985,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-160850',
      type: 'REFUND',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      balance: 0,
      createAt: '2025-12-17T15:52:05.478051Z',
      details: null
    },
    {
      id: 985,
      amount: 5.0,
      description: '',
      reference: 'REC17122025-160850',
      type: 'REFUND',
      status: 'COMPLETED',
      wallet: {
        id: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
        balance: 15.0,
        documentNumber: 'AAJ332971',
        currency: {
          code: 'USD',
          label: 'USD',
          exchangeBuy: 1.0,
          exchangeSell: 1.0,
          mainCurrency: true
        },
        status: 'ACTIVE'
      },
      createAt: '2025-12-17T15:52:05.478051Z',
      details: {},
      balance: 0
    }
  ],
  summary: {
    totalAmount: 8037.91
  }
}

export const clientPersonalData: { data: PersonalDataResponse } = {
  data: {
    clientAddress: {
      name: '',
      address: 'ergeg',
      lat: '7.585652648881443',
      lng: '-66.06930137760209',
      isFavorite: true,
      referencePoint: 'HWPJ+77 Caicara del Orinoco, Bolívar, Venezuela',
      state: 1,
      city: 104,
      sectorId: 409,
      id: '12',
      createdAt: ''
    },
    gender: 'FEMENINO',
    occupation: 'Ingeniero de Software en weppa',
    maritalStatus: 'DIVORCIADO',
    clientId: 131,
    accountType: 'AHORRO',
    accountNumber: '353464647'
  }
}

export const activitySummary: { data: ActivitySummaryResponse } = {
  data: {
    clientId: 2,
    documentNumber: '123456',
    fullName: 'Grisel Estrada',
    phone: '+58123456788',
    email: 'genamorado88@gmail.com',
    walletPublicId: 'a80b2eb6-d17e-46e7-98e7-de60152370bc-client',
    rechargedPhones: [
      {
        phoneNumber: '04149876543',
        documentNumber: '87654321',
        fullName: 'Jose Garcia',
        rechargeCount: 3,
        lastRechargeAt: '2026-07-08T18:24:10Z'
      },
      {
        phoneNumber: '04241234567',
        documentNumber: '11222333',
        fullName: 'Ana Rodriguez',
        rechargeCount: 1,
        lastRechargeAt: '2026-06-20T11:05:00Z'
      }
    ],
    transferRecipients: [
      {
        walletId: 91,
        walletPublicId: 'def456-client',
        documentNumber: '87654321',
        phone: '04149876543',
        fullName: 'Jose Garcia',
        transferCount: 2,
        lastTransferAt: '2026-07-07T15:12:00Z'
      }
    ],
    transferSenders: [
      {
        walletId: 72,
        walletPublicId: 'ghi789-client',
        documentNumber: '11222333',
        phone: '04241234567',
        fullName: 'Ana Rodriguez',
        transferCount: 1,
        lastTransferAt: '2026-07-06T09:30:00Z'
      }
    ],
    paymentMobileAndAddresses: {
      mobilePaymentPhones: [
        {
          phoneNumber: '+58123456788',
          paymentCount: 4,
          lastUsedAt: '2026-07-05T20:01:33Z'
        }
      ],
      addresses: [
        {
          address: 'Venezuela, Miranda, Caracas, Av. Principal',
          source: 'client.dat_client.address'
        }
      ]
    },
    loginActivities: [
      {
        userClientId: 555,
        email: 'genamorado88@gmail.com',
        phone: '+58123456788',
        lastActivity: '2026-07-08T22:10:45Z',
        createdAt: '2026-01-15T12:00:00Z',
        updatedAt: '2026-07-08T22:10:45Z',
        source: 'security.dat_user_client.last_activity'
      }
    ]
  }
}

export const personalDocs: { data: PersonalDocsResponseSchema } = {
  data: {
    rifImage: mockDocumentImage,
    idCardImage: mockDocumentImage,
    driverLicenseImage: mockDocumentImage,
    medicalCertificateFrontImage: mockDocumentImage,
    medicalCertificateBackImage: mockDocumentImage,
    letterResidence: mockDocumentImage,
    id: 1
  }
}
